const steps = [
  {
    disableBeacon: true,
    target: '.chart-area',
    title: 'Grafico',
    content: 'Qui trovi il grafico generato su base dell\'ultimo mese',
    placement: "right",
  },
  {
    target: '.site-map',
    title: 'Mappa',
    content: 'Se esistente, puoi visualizzare la mappa del punto vendita',
    placement: "left",
  },
  {
    target: '.site-map-visual',
    title: 'Mappa',
    content: 'Cliccando la mappa puoi ingrandirla',
    placement: "left",
    clickOnPreviousElementBeforeEntering: true,
  },
  {
    target: '.variables-table',
    title: 'Variabili',
    content: 'Puoi visualizzare e interagire con le variabili',
    placement: "left",
  },
  {
    target: '.variables-select',
    title: 'Selezione variabili',
    content: 'Puoi scegliere quali variabili visualizzare nel grafico',
    placement: "left",
    clickOnPreviousElementBeforeEntering: true,
  },
  {
    target: '.variables-color',
    title: 'Colore variabili',
    content: 'Puoi scegliere il colore delle variabili',
    placement: "left",
  },
  {
    target: '.variables-confirm',
    title: 'Conferma',
    content: 'Conferma le modifiche effettuate',
    placement: "top",
  },
  {
    target: '.period-selector',
    title: 'Periodo',
    content: 'Scegli per quale periodo generare il grafico',
    clickOnElementBeforeEntering: '#closeVariablesModalButton',
  },
  {
    target: '.period_last_month',
    title: 'Ultimo mese',
    content: 'Filtra per ultimo mese',
    clickOnPreviousElementBeforeEntering: true,
  },
  {
    target: '.period_month',
    title: 'Mensile',
    content: 'Filtra per un mese e un anno specifico',
    clickOnElementOnEntering: true,
  },
  {
    target: '#monthPicker',
    title: 'Mese',
    content: 'Cambia mese',
  },
  {
    target: '#yearPicker',
    title: 'Anno',
    content: 'Cambia anno',
  },
  {
    target: '.period_custom',
    title: 'Personalizzato',
    content: 'Filtra per un range di date personalizzato',
    clickOnElementOnEntering: true,
  },
  {
    target: '#startDatePicker',
    title: 'Data inizio',
    content: 'Cambia data inizio', 
  },
  {
    target: '#endDatePicker',
    title: 'Data fine',
    content: 'Cambia data fine', 
  },
  {
    target: '.frequency-input',
    title: 'Frequenza',
    content: 'Scegli la frequenza di campionamento dei dati',
  },
  {
    target: '.download-report-button',
    title: 'Download report',
    content: 'Scarica un report in formato pdf basato sui filtri attuali',
    clickOnElementBeforeEntering: '#closeVariablesModalButton',
  },
  {
    target: '.update-chart-button',
    title: 'Aggiorna grafico',
    content: 'Aggiorna i dati del grafico in base alle variabili selezionate',
  },
];

export default steps;
